import { defineMessages } from 'react-intl';
import {
  addDefaultOptions,
  templatesOptions,
  addLinkMoreOptions,
} from 'design-comuni-plone-theme/config/Blocks/ListingOptions';
import { cloneBlock } from 'design-comuni-plone-theme/helpers/blocks';
import ListTemplate from 'rer-theme/components/Blocks/Listing/List/ListTemplate';
import ListTemplateSkeleton from 'rer-theme/components/Blocks/Listing/List/Skeleton';

const messages = defineMessages({
  show_image: {
    id: 'show_image',
    defaultMessage: "Mostra l'immagine",
  },
});

export const addListingVariation_List = (config) => {
  config.blocksConfig.listing.variations = [
    ...config.blocksConfig.listing.variations,
    {
      id: 'list',
      isDefault: false,
      title: 'Layout orizzontale',
      template: ListTemplate,
      skeleton: ListTemplateSkeleton,
      schemaEnhancer: ({ schema, formData, intl }) => {
        let pos = addDefaultOptions(schema, formData, intl);

        pos = templatesOptions(
          schema,
          formData,
          intl,
          ['show_image', 'show_description', 'hide_dates'],
          {
            show_image: {
              default: true,
              label: intl.formatMessage(messages.show_image),
            },
            hide_dates: { default: false },
          },

          pos,
        );

        addLinkMoreOptions(schema, formData, intl);
        return schema;
      },
      cloneData: cloneBlock,
    },
  ];
};
